const defaultConfig = {};

const configReducer = (state = defaultConfig, action) => {
  switch (action.type) {
    case 'SET_CONFIG':
      return {
        ...state,
        countryList: action.config.countryList,
        addressfinder: action.config.addressfinder,
        basename: action.config.basename,
        timeout: action.config.timeout,
        registrationFormType: action.config.registrationFormType,
        addRedirects: action.config.addRedirects,
        notFoundContent: action.config.notFoundContent,
        content: action.config.content,
        title: action.config.title,
      };
    default:
      return state;
  }
};

export default configReducer;
